module.exports = __webpack_public_path__ + "static/img/2.5add5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news20/2.png
// module id = 6krk
// module chunks = 1